var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatemineIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 200,
    viewBox: "0 0 200 200",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    fill: "#000",
    r: 100
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.1305 75.5093c-4.9017-18.2936 5.9544-37.0971 24.2479-41.9988 4.9134 18.3361 3.9738 14.8298 8.8755 33.1234 4.9018 18.2936 3.9622 14.7873 8.8751 33.1235-18.2933 4.9016-37.0967-5.9545-41.9985-24.2481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.006 124.248c4.902 18.294-5.954 37.097-24.248 41.999-4.913-18.336-3.973-14.83-8.875-33.124-4.902-18.293-3.962-14.787-8.876-33.123 18.294-4.9018 37.097 5.954 41.999 24.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.2286 166.209c-13.3918-13.392-13.3919-35.104-.0001-48.496 13.4232 13.423 10.8563 10.856 24.2481 24.248 13.3914 13.392 10.8254 10.825 24.2484 24.248-13.392 13.392-35.1045 13.392-48.4964 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.752 33.7524c13.392 13.3919 13.392 35.1042 0 48.496-13.423-13.4228-10.856-10.8561-24.248-24.248-13.3919-13.3918-10.825-10.825-24.248-24.2481 13.3917-13.3917 35.104-13.3917 48.496.0001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatemineIcon);
export default __webpack_public_path__ + "static/media/statemine-icon.b6c268c2.svg";
export { ForwardRef as ReactComponent };